import React, { useMemo } from 'react';
import { string } from 'prop-types';
import Checkbox from '@active/react-ui/Checkbox';
import CheckboxGroup from '@active/react-ui/CheckboxGroup';
import FormGroup from '@active/react-ui/FormGroup';
import FormField from '@active/react-ui/FormField';
import FormLabel from '@active/react-ui/FormLabel';
import { useLocale } from '@active/react-utils/i18n';
import { currency } from '../../../../../../../Currency';
import I18nMessage from '../../../../../../../messages/I18nMessage';
import useCurrentAmountAndCreditBalance from '../../../../../../../../../shared/utils/currentAmountAndCreditBalance/useCurrentAmountAndCreditBalance';

const getMandateCheckboxText = ({
  type, i18n, amount, currencyCode, dateOfSignature, locale, accountType,
}) => {
  const mandateConsentId = type === 'EUDD' ? 'checkout.lib.components.payment.echeck.eudd.mandateConsent'
    : 'checkout.lib.components.payment.echeck.ecp.mandateConsent';
  const payAmount = currency({ amount, locale, code: currencyCode });
  const accountTypeId = i18n(`checkout.lib.components.payment.echeck.${accountType}`);
  const params = {
    0: accountType && <span>
      {accountTypeId}
      {' '}
    </span>,
    1: dateOfSignature,
    2: payAmount,
  };
  return <I18nMessage id={mandateConsentId} values={params} />;
};

const MandateCheckbox = (props) => {
  const {
    type, currencyCode, dateOfSignature, locale, accountType,
  } = props;
  const { i18n } = useLocale();
  const { yourPayment } = useCurrentAmountAndCreditBalance();
  const mandateConsentText = useMemo(() => getMandateCheckboxText({
    type, currencyCode, dateOfSignature, locale, accountType, amount: yourPayment, i18n,
  }),
  [ i18n, yourPayment, type, currencyCode, dateOfSignature, locale, accountType ]);

  return (
    <div className="mandate-checkbox cui-mg-t-15">
      <FormGroup name="mandateConsent" className="checkout-ui-checkbox__group" required>
        <FormLabel></FormLabel>
        <FormField as={CheckboxGroup} >
          <Checkbox
            value="true"
            tabIndex="0">
            {mandateConsentText}
          </Checkbox>
        </FormField>
      </FormGroup>
    </div>
  );
};

MandateCheckbox.propTypes = {
  type: string.isRequired,
  currencyCode: string,
  locale: string,
  dateOfSignature: string,
  accountType: string,
};

export default MandateCheckbox;
